module.exports = __webpack_public_path__ + "img/horizontal_3_3_9006.534fd37e.png";